<template>
    <!-- The Planing Poker mark drawn with the current text color, to be used in the corners of the cards. -->
    <svg viewBox="0 0 36 36" fill="none" aria-hidden="true">
        <rect x="3" y="7" width="20" height="26" rx="4" stroke="currentColor" stroke-width="2.4" opacity=".55" transform="rotate(-10 13 20)" />
        <rect x="12" y="3" width="20" height="26" rx="4" fill="#FFFFFF" stroke="currentColor" stroke-width="2.4" />
        <circle cx="22" cy="16" r="4" fill="currentColor" />
    </svg>
</template>
